import { render, staticRenderFns } from "./OnBoardingDot.vue?vue&type=template&id=1bb8a3f8"
import script from "./on-boarding-dot.ts?vue&type=script&lang=ts&external"
export * from "./on-boarding-dot.ts?vue&type=script&lang=ts&external"
import style0 from "./on-boarding-dot.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports